var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-main"},[_c('div',{staticClass:"agess",attrs:{"id":"age2"}})])
}]

export { render, staticRenderFns }